import deployments from './deployments';
import trials from './trials';
import analytics from './analytics';
import digitalUnits from './digital-units';
import settings from './settings';

const menuItems = {
    items: [deployments, trials, digitalUnits, analytics, settings]
};

export default menuItems;
